import { createFileRoute } from "@tanstack/react-router";
import {
  clientDetailsQueryOptions,
  distributorEmployeeByIdQueryOptions,
  getDistributorBrandingOptions,
  getDistributorProfileOptions,
  getUserOptions,
  portfolioReviewFrozenOverviewQueryOptions,
  portfolioReviewQueryOptions,
  portfolioReviewReportQueryOptions,
} from "creso-core/hooks";
import { PortfolioReviewReport } from "@/modules/reports/pages/portfolio-review";

export const Route = createFileRoute(
  "/(auth)/(headless)/reports/clients/$id/portfolio-review/$reviewId"
)({
  component: PortfolioReviewReport,
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const reviewId = Number(params.reviewId);
    const userPromise = queryClient.fetchQuery(getUserOptions(true));
    const clientPromise = queryClient.fetchQuery(
      clientDetailsQueryOptions(Number(params.id))
    );
    const distributorProfilePromise = queryClient.fetchQuery(
      getDistributorProfileOptions(true)
    );
    const distributorBrandingPromise = queryClient.fetchQuery(
      getDistributorBrandingOptions(true)
    );
    const reviewPromise = queryClient.fetchQuery(
      portfolioReviewQueryOptions(reviewId)
    );
    const reportPromise = queryClient.fetchQuery(
      portfolioReviewReportQueryOptions(reviewId)
    );
    // Only the external holdings pages read it, so a failure drops them alone.
    const overviewPromise = queryClient
      .fetchQuery(portfolioReviewFrozenOverviewQueryOptions(reviewId))
      .catch(() => null);

    const client = await clientPromise;
    if (!client) {
      throw new Error("Client not found");
    }

    const user = await userPromise;
    const metadata =
      user?.metadata && typeof user.metadata === "object"
        ? (user.metadata as Record<string, unknown>)
        : null;
    const rawEmployeeId = metadata?.id ?? null;
    const employeeId =
      user?.user_type === "employee" && rawEmployeeId != null
        ? Number(rawEmployeeId)
        : undefined;
    const employee =
      employeeId != null && !Number.isNaN(employeeId)
        ? await queryClient.fetchQuery(
            distributorEmployeeByIdQueryOptions(employeeId, { enabled: true })
          )
        : null;

    return {
      client,
      employee,
      distributorProfile: await distributorProfilePromise,
      distributorBranding: await distributorBrandingPromise,
      review: await reviewPromise,
      report: await reportPromise,
      overview: await overviewPromise,
    };
  },
});
